import React from "react";
import { useAtom } from "jotai";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Grid,
    Button,
    Typography
} from "@mui/material";
import { isMbxUserProvider, isMbxUserVerifiedStaff } from "../atoms/atoms";
import { ThemeProvider, useTheme } from "@mui/material/styles";
import { DialogTheme } from "../styles/DialogTheme";

export const VMDialog = ({
    openVMDialog,
    onClose,
    inProgress = false,
    serviceProv,
    clientName,
    startDate,
    serviceLoc
}) => {
    const theme = useTheme();
    const [isProviderLoggedIn] = useAtom(isMbxUserProvider);
    const [isVerifiedStaff] = useAtom(isMbxUserVerifiedStaff);
    return (
        <ThemeProvider theme={DialogTheme(theme)}>
            <Dialog
                maxWidth={"sm"}
                open={openVMDialog}
                onClose={onClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    Join virtual appointment
                </DialogTitle>
                {isProviderLoggedIn && inProgress && (
                    <DialogContent>
                        <Typography>
                            Would you like to join this virtual meeting room
                            with client {clientName}?
                        </Typography>
                    </DialogContent>
                )}
                {isProviderLoggedIn && !inProgress && (
                    <DialogContent>
                        <Typography>
                            You will have a virtual appointment with client{" "}
                            {clientName} on
                            {startDate} – would you like to join this meeting
                            room now?
                        </Typography>
                    </DialogContent>
                )}
                {isVerifiedStaff && inProgress && (
                    <DialogContent>
                        <Typography>
                            Provider {serviceProv} is currently in a virtual
                            meeting with client {clientName} – would you like to
                            join this meeting room?
                        </Typography>
                    </DialogContent>
                )}
                {isVerifiedStaff && !inProgress && (
                    <DialogContent>
                        <Typography>
                            Provider {serviceProv} will have a virtual meeting
                            with client {clientName} on {startDate} – would you
                            like to join this meeting room now?
                        </Typography>
                    </DialogContent>
                )}
                <DialogActions>
                    <Grid
                        container
                        item
                        gap={"18px"}
                        sx={{
                            display: "flex",
                            justifyContent: "flex-end"
                        }}
                    >
                        <Button
                            variant="outlined"
                            onClick={onClose}
                            sx={{
                                borderColor: "primary.main"
                            }}
                        >
                            Cancel
                        </Button>
                        <Button
                            disabled={serviceLoc === ""}
                            onClick={() => {
                                const url = serviceLoc.replace(
                                    /^https?:\/\//,
                                    ""
                                );
                                window.open(`https://${url}`, "_blank");
                                onClose();
                            }}
                            variant="contained"
                            autoFocus
                        >
                            Join
                        </Button>
                    </Grid>
                </DialogActions>
            </Dialog>
        </ThemeProvider>
    );
};
